<template>
  <div>
    <h6 class="m-0 font-weight-bold text-primary">Detail Order</h6>
    <table class="table table-bordered">
      <thead>
        <tr>
          <th>Info</th>
          <th>Amount</th>
          <th>Price</th>
          <th>Total</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(detail, key) in data.detail" :key="key">
          <td>{{ detail.helper_sub_sub_category.name }}</td>
          <td class="text-right">{{ detail.amount.toLocaleString('id-ID') }}</td>
          <td class="text-right">Rp. {{ detail.price.toLocaleString('id-ID') }}</td>
          <td class="text-right">Rp. {{ (detail.amount * detail.price).toLocaleString('id-ID') }}</td>
        </tr>
        <tr>
          <td colspan="3" class="text-center">Sub-Total</td>
          <td class="text-right">Rp. {{ data.total_price.toLocaleString('id-ID') }}</td>
        </tr>
        <tr>
          <td colspan="3" class="text-center">Admin Fee</td>
          <td class="text-right">Rp. {{ data.admin_fee.toLocaleString('id-ID') }}</td>
        </tr>
        <tr>
          <td colspan="3" class="text-center">Discount</td>
          <td class="text-right">Rp. {{ data.discount.toLocaleString('id-ID') }}</td>
        </tr>
        <tr>
          <td colspan="3" class="text-center">Total</td>
          <td class="text-right">Rp. {{ data.grand_total.toLocaleString('id-ID') }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default{
  props: ['data',],
  data(){
    return{
      sub_total: 0,
    }
  },
  watch:{
    data(val){
      var sub_total = 0
      for(let x in val.detail)
        sub_total += val.detail[x].amount * val.detail[x].price
      this.sub_total = sub_total
    },
  },
}
</script>
